import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { PrimaryButton } from '../../../../Button/Button';
import NamedLink from '../../../../NamedLink/NamedLink';
// import homeDesignsIcon from './images/homeDesigns.png';
// import uploadDesignsIcon from './images/uploadDesigns.png';
// import howItWorksIcon from './images/howItWorks.png';
// import discoverMMCIcon from './images/discoverMMC.png';
// import communityIcon from './images/aboutUs.png';
// import blogsIcon from './images/blogs.png';
// import newsletterIcon from './images/newsletter.png';
// import playCircleIcon from './images/playCircle.png';
// import speakIcon from './images/speakIcon.png';
import { deduplicateAndSplitColumns } from '../../../../../util/genericHelpers';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Icons from '../../../../Icons/Icons';
import Modal from '../../../../Modal/Modal';
import bannerVideo from '../../../../../assets/bannerVideo.mp4';
import { apiBaseUrl } from '../../../../../util/api';

import css from './HoverMenuWide.module.css';
import { manageDisableScrolling } from '../../../../../ducks/ui.duck';
import { useDispatch } from 'react-redux';
import SmartLink from '../../../../SmartLink/SmartLink';
import CHAT from './images/speakTothem.png';

// OLD MENU STRUCTURE - COMMENTED OUT FOR NEW DESIGN
// const homeDesignLinks = [
//   { id: 'HoverMenuWide.rural', type: 'rural' },
//   { id: 'HoverMenuWide.suburban', type: 'suburban' },
//   { id: 'HoverMenuWide.urban', type: 'urban' },
//   { id: 'HoverMenuWide.bungalows', type: 'bungalows' },
//   { id: 'HoverMenuWide.viewAllHomeDesigns', href: '/home-designs' },
//   { id: 'HoverMenuWide.buildingPlots', href: '/', isDisabled: true },
// ];

const HoverMenuWide = ({ hoverMenuOpened, setHoverMenuOpened, isAuthenticated, currentUser }) => {
  const menuRef = useRef(null);
  const intl = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const [isGeneratingToken, setIsGeneratingToken] = useState(false);

  // Get environment variables for LeadFlow
  const leadflowSignupUrl = process.env.REACT_APP_LEADFLOW_SIGNUP_URL;
  const leadflowAppUrl = process.env.REACT_APP_LEADFLOW_APP_URL;

  // Check LeadFlow access
  const isLeadflowAccessProvided = currentUser?.attributes?.profile?.publicData?.isLeadflowAccessProvided;

  // Handle SSO token generation and redirect to LeadFlow
  const handleAccessLeadFlow = async () => {
    try {
      setIsGeneratingToken(true);

      console.log('[ViewLeads] User clicked View Leads - generating SSO token');

      // Build API URL
      const apiUrl = `${apiBaseUrl()}/api/leadflow/generate-sso-token`;
      console.log('API URL:', apiUrl);

      // Call backend to generate SSO token
      const response = await fetch(apiUrl, {
        method: 'POST',
        credentials: 'include', // Include cookies for authentication
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      console.log('Response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('API error:', errorData);
        throw new Error(errorData.message || 'Failed to generate SSO token');
      }

      const data = await response.json();
      console.log('API response:', data);

      if (data.success && data.data.redirectUrl) {
        console.log('SSO token generated, redirecting to:', data.data.redirectUrl);
        // Open LeadFlow in a new tab with SSO token
        window.open(data.data.redirectUrl, '_blank');
        setIsGeneratingToken(false);
      } else {
        console.error('Invalid response format:', data);
        alert('Failed to access LeadFlow. Please try again or contact support.');
        setIsGeneratingToken(false);
      }
    } catch (error) {
      console.error('LeadFlow SSO error:', error);
      alert(`Error accessing LeadFlow: ${error.message}`);
      setIsGeneratingToken(false);
    }
  };

  // Get second button config for LeadFlow menu based on authentication and access
  const getLeadFlowSecondButton = () => {
    if (!isAuthenticated) {
      // Not logged in - redirect to login page
      return {
        label: 'Log in',
        href: '/login',
        pageName: 'LoginPage',
        color: 'red',
      };
    } else if (!isLeadflowAccessProvided) {
      // Logged in but no access - redirect to external signup URL
      return {
        label: 'Try Leadflow for free',
        href: leadflowSignupUrl,
        color: 'red',
        isExternal: true,
      };
    } else {
      // Logged in with access - use SSO to access LeadFlow
      return {
        label: isGeneratingToken ? 'Connecting...' : 'View Leads',
        onClick: handleAccessLeadFlow,
        color: 'red',
        disabled: isGeneratingToken,
      };
    }
  };

  // Click outside handler removed - now handled by parent onMouseLeave
  // useEffect(() => {
  //   const handleClickOutside = event => {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       setHoverMenuOpened(null);
  //     }
  //   };
  //   document.addEventListener('click', handleClickOutside);
  //   return () => document.removeEventListener('click', handleClickOutside);
  // }, [setHoverMenuOpened]);

  // OLD MENU_CONFIG - COMMENTED OUT FOR NEW DESIGN
  // const MENU_CONFIG = {
  //   'Home designs': {
  //     columns: [
  //       [
  //         {
  //           icon: homeDesignsIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.howItWorks' }),
  //           href: '/how-it-works',
  //           pageName: 'HowItWorksPage',
  //         },
  //       ],
  //       homeDesignLinks.map(({ id, type, href, isDisabled = false }) => ({
  //         icon: uploadDesignsIcon,
  //         label: intl.formatMessage({ id }),
  //         isDisabled,
  //         pageName: 'SearchPage',
  //         to: { search: `?pub_house_type=${type}` },
  //       })),
  //     ],
  //     visit: {
  //       title: intl.formatMessage({ id: 'HoverMenuWide.visitMarketplaceTitle' }),
  //       description: intl.formatMessage({ id: 'HoverMenuWide.visitMarketplaceDescription' }),
  //       buttons: [
  //         {
  //           label: intl.formatMessage({ id: 'HoverMenuWide.viewMarketplace' }),
  //           href: '/home-designs',
  //           pageName: 'SearchPage',
  //         },
  //         {
  //           label: intl.formatMessage({ id: 'HoverMenuWide.joinMarketplace' }),
  //           href: '/signup',
  //           pageName: 'SignupPage',
  //         },
  //       ],
  //     },
  //   },
  //   'Trusted Suppliers': {
  //     columns: [
  //       [
  //         {
  //           icon: howItWorksIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.landFinding' }),
  //           href: '/land-finding',
  //           pageName: 'LandFindingPage',
  //         },
  //         {
  //           icon: discoverMMCIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.finance' }),
  //           href: '/finance',
  //           pageName: 'FinancePage',
  //         },
  //         {
  //           icon: communityIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.insurance' }),
  //           href: '/insurance',
  //           pageName: 'InsuranceAndFinancePage',
  //         },
  //         {
  //           icon: communityIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.architects' }),
  //           href: '/architects-planning-consultancy',
  //           pageName: 'ArchitectsAndPlanningConsultancyPage',
  //         },
  //         {
  //           icon: communityIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.offsiteSuppliers' }),
  //           href: '/offsite-suppliers',
  //           pageName: 'OffsiteSuppliersPage',
  //         },
  //       ],
  //       [
  //         {
  //           icon: howItWorksIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.structuralEngineers' }),
  //           href: '/structural-engineers',
  //           pageName: 'StructuralEngineersPage',
  //         },
  //         {
  //           icon: discoverMMCIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.groundworks' }),
  //           href: '/groundworks-contractors',
  //           pageName: 'GroundworksContractorsPage',
  //         },
  //       ],
  //     ],
  //     visit: {
  //       title: intl.formatMessage({ id: 'HoverMenuWide.visitSuppliersTitle' }),
  //       description: intl.formatMessage({ id: 'HoverMenuWide.visitSuppliersDescription' }),
  //       buttons: [
  //         {
  //           label: intl.formatMessage({ id: 'HoverMenuWide.trustedSuppliers' }),
  //           href: '/trusted-suppliers',
  //           pageName: 'TrustedSuppliersPage',
  //         },
  //         {
  //           label: intl.formatMessage({ id: 'HoverMenuWide.advertise' }),
  //           isExternal: true,
  //           href: 'https://calendly.com/themodernbuilder/customer-experience',
  //         },
  //       ],
  //     },
  //   },
  //   Community: {
  //     columns: [
  //       [
  //         {
  //           icon: communityIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.caseStudies' }),
  //           href: '/community',
  //           pageName: 'CommunityPage',
  //         },
  //         {
  //           icon: newsletterIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.newsletters' }),
  //           isExternal: true,
  //           href: '/static/media/newsletter1.ae396ef2d14071401d45.pdf',
  //         },
  //         {
  //           icon: communityIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.webinars' }),
  //           isDisabled: true,
  //           href: '/',
  //           pageName: 'LandingPage',
  //         },
  //         {
  //           icon: blogsIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.blogs' }),
  //           href: '/blogs',
  //           pageName: 'BlogPage',
  //         },
  //       ],
  //       [
  //         {
  //           icon: newsletterIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.offsiteConstruction' }),
  //           href: '/offsite-construction',
  //           pageName: 'CustomOffsiteConstructionPage',
  //         },
  //         {
  //           icon: newsletterIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.costCalculator' }),
  //           href: '/self-build-blogs/how-much-does-it-cost-to-self-build-a-house-in-2025',
  //           pageName: 'CostCalculatorPage',
  //         },
  //       ],
  //     ],
  //     visit: {
  //       title: intl.formatMessage({ id: 'HoverMenuWide.communityTitle' }),
  //       description: intl.formatMessage({ id: 'HoverMenuWide.communityDescription' }),
  //       buttons: [
  //         {
  //           label: intl.formatMessage({ id: 'HoverMenuWide.communityBtn' }),
  //           href: '/community',
  //           pageName: 'CommunityPage',
  //         },
  //       ],
  //     },
  //   },
  //   'About Us': {
  //     columns: [
  //       [
  //         {
  //           icon: communityIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.whoWeAre' }),
  //           href: '/about',
  //           pageName: 'AboutUsPage',
  //         },
  //         {
  //           icon: blogsIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.blogs' }),
  //           href: '/blogs',
  //           pageName: 'BlogPage',
  //         },
  //         {
  //           icon: communityIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.faqs' }),
  //           href: '/faq',
  //           pageName: 'FaqPage',
  //         },
  //       ],
  //       [
  //         {
  //           icon: newsletterIcon,
  //           label: intl.formatMessage({ id: 'HoverMenuWide.forInvestors' }),
  //           isDisabled: true,
  //           href: '/',
  //           pageName: 'LandingPage',
  //         },
  //       ],
  //     },
  //   },
  // };

  // NEW MENU CONFIG BASED ON DESIGN
  const NEW_MENU_CONFIG = {
    'LeadFlow': {
      title: 'Construction Leads. Fast',
      description: 'Early access to live UK planning data & Outreach',
      links: [
        { label: 'Book demo', href: 'https://calendly.com/themodernbuilder/discovery', color: 'red', isExternal: true },
        getLeadFlowSecondButton(),
      ],
      showSpeakToTeam: true,
    },
    'Marketplace': {
      title: 'Visit Market Place',
      description: 'Find suitable designs, compare options, and start building',
      links: [
        { label: 'View Marketplace', href: '/home-designs', pageName: 'SearchPage', color: 'red' },
        { label: 'Log in', href: '/login', pageName: 'LoginPage', color: 'red' },
      ],
      showSpeakToTeam: true,
    },
    'Trusted Suppliers': {
      title: 'Visit Trusted Suppliers',
      description: 'Verified. Experienced. Ready to quote.',
      links: [
        { label: 'Trusted Suppliers', href: '/trusted-suppliers', pageName: 'TrustedSuppliersPage', color: 'red' },
        { label: 'Advertise Your Services', href: 'https://calendly.com/themodernbuilder/customer-experience', color: 'red', isExternal: true },
      ],
      showSpeakToTeam: true,
    },
    'Resources': {
      links: [
        { label: 'Blogs', href: '/blogs', pageName: 'BlogPage' },
        { label: 'About Us', href: '/about', pageName: 'AboutUsPage' },
        { label: 'Construction Budget Planner', href: '/cost-estimation', pageName: 'CostEstimationDetailsPage' },
        { label: 'Cost Calculator', href: '/self-build-blogs/how-much-does-it-cost-to-self-build-a-house-in-2026', pageName: 'CostCalculatorPage' },
      ],
      cta: {
        text: 'Ready to get started?',
        linkText: 'Log in',
        href: '/login',
        pageName: 'LoginPage',
      },
    },
  };

  // OLD RENDERING CODE - COMMENTED OUT
  // if (!hoverMenuOpened || !MENU_CONFIG[hoverMenuOpened]) return null;
  // const config = MENU_CONFIG[hoverMenuOpened];
  // const [part1, part2] = deduplicateAndSplitColumns(config.columns);

  // NEW RENDERING CODE
  if (!hoverMenuOpened || !NEW_MENU_CONFIG[hoverMenuOpened]) return null;

  const config = NEW_MENU_CONFIG[hoverMenuOpened];

  // Check if menu has CTAs (red links) - for side-by-side layout
  const hasCTAs = config.links.some(link => link.color === 'red');

  return (
    <div className={css.newWrapper} ref={menuRef} key={hoverMenuOpened}>
      <div className={css.newDropdownContent}>
        {config.title && (
          <div className={css.dropdownHeader}>
            <h3 className={css.dropdownTitle}>{config.title}</h3>
            <p className={css.dropdownDescription}>{config.description}</p>
          </div>
        )}

        <div className={`${css.dropdownLinks} ${!hasCTAs ? css.dropdownLinksVertical : ''}`}>
          {config.links.map((link, idx) => {
            // If link has onClick handler, render as button instead of link
            if (link.onClick) {
              return (
                <button
                  key={idx}
                  className={`${css.dropdownLink} ${link.color === 'red' ? css.redLink : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setHoverMenuOpened(null);
                    link.onClick();
                  }}
                  disabled={link.disabled}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: link.disabled ? 'not-allowed' : 'pointer',
                    opacity: link.disabled ? 0.6 : 1,
                    textAlign: 'left',
                  }}
                >
                  {link.label} {link.color === 'red' && <span className={css.arrow}>→</span>}
                </button>
              );
            }

            // Regular link rendering
            return (
              <SmartLink
                key={idx}
                href={link.href}
                pageName={link.pageName}
                className={`${css.dropdownLink} ${link.color === 'red' ? css.redLink : ''}`}
                onClick={() => setHoverMenuOpened(null)}
                isExternal={link.isExternal}
              >
                {link.label} {link.color === 'red' && <span className={css.arrow}>→</span>}
              </SmartLink>
            );
          })}
        </div>

        {config.cta && (
          <div className={css.dropdownCta}>
            <p className={css.ctaText}>
              {config.cta.text}{' '}
              <SmartLink
                href={config.cta.href}
                pageName={config.cta.pageName}
                className={css.ctaLink}
                onClick={() => setHoverMenuOpened(null)}
              >
                {config.cta.linkText}
              </SmartLink>
            </p>
          </div>
        )}

        {config.showSpeakToTeam && (
          <div className={css.dropdownFooter}>
            <SmartLink
              className={css.speakToTeamLink}
              href="https://calendly.com/themodernbuilder/customer-support"
              isExternal
              onClick={() => setHoverMenuOpened(null)}
            >
              {/* Play/Video Icon */}
              {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <path d="M10 8L16 12L10 16V8Z" fill="currentColor"/>
              </svg> */}
              {/* Chat Icon */}
             <img src={CHAT}/>

              <span>Speak to the team</span>
            </SmartLink>
          </div>
        )}
      </div>
    </div>
  );

  // OLD RETURN CODE - COMMENTED OUT
  // return (
  //   <div className={css.wrapper} ref={menuRef} key={hoverMenuOpened}>
  //     <div className={css.columnsWrapper}>
  //       <div className={css.columnParts}>
  //         <div className={css.column}>
  //           {part1.map(item => (
  //             <SmartLink
  //               key={item.href + item.label}
  //               href={item?.isDisabled ? undefined : item.href}
  //               className={`${css.columnItem} ${item?.isDisabled ? css.disabled : ''}`}
  //               onClick={e => {
  //                 if (item?.isDisabled) {
  //                   e.preventDefault();
  //                   return;
  //                 }
  //                 setHoverMenuOpened(null);
  //               }}
  //               isExternal={item?.isExternal}
  //               pageName={item?.pageName}
  //               to={item?.to}
  //             >
  //               {item.label}{' '}
  //               {item?.isDisabled ? (
  //                 <span className={css.disabledIcon}>
  //                   <Icons name="lock" />
  //                 </span>
  //               ) : null}
  //             </SmartLink>
  //           ))}
  //         </div>
  //         <div className={css.column}>
  //           {part2.map(item => (
  //             <SmartLink
  //               key={item.href + item.label}
  //               href={item?.isDisabled ? undefined : item.href}
  //               className={`${css.columnItem} ${item?.isDisabled ? css.disabled : ''}`}
  //               onClick={e => {
  //                 if (item?.isDisabled) {
  //                   e.preventDefault();
  //                   return;
  //                 }
  //                 setHoverMenuOpened(null);
  //               }}
  //               isExternal={item?.isExternal}
  //               pageName={item?.pageName}
  //               to={item?.to}
  //             >
  //               {item.label}{' '}
  //               {item?.isDisabled ? (
  //                 <span className={css.disabledIcon}>
  //                   <Icons name="lock" />
  //                 </span>
  //               ) : null}
  //             </SmartLink>
  //           ))}
  //         </div>
  //       </div>
  //       <div className={css.columnParts}>
  //         {config.visit && (
  //           <div className={css.visitSec}>
  //             <h2>{config.visit.title}</h2>
  //             <p>{config.visit.description}</p>
  //             <div className={css.visitBtnWrapper}>
  //               {config.visit.buttons.map(btn => (
  //                 <PrimaryButton
  //                   key={btn.label}
  //                   className={css.viewBtn}
  //                   disabled={btn?.isDisabled}
  //                   onClick={() => {
  //                     if (!btn?.isDisabled) {
  //                       setHoverMenuOpened(null);
  //                       if (btn.isExternal) {
  //                         typeof window !== 'undefined' && window.open(btn.href, '_blank');
  //                       } else {
  //                         history.push(btn.href);
  //                       }
  //                     }
  //                   }}
  //                 >
  //                   {btn.label}
  //                 </PrimaryButton>
  //               ))}
  //             </div>
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //     <div className={css.ctaWrapper}>
  //       {!isAuthenticated && (
  //         <p className={css.loginText}>
  //           <FormattedMessage id="HoverMenuWide.signupPrompt" />{' '}
  //           <NamedLink
  //             name="SignupPage"
  //             className={css.signupLink}
  //             onClick={() => setHoverMenuOpened(null)}
  //           >
  //             <FormattedMessage id="HoverMenuWide.signupBtn" />
  //           </NamedLink>
  //         </p>
  //       )}
  //       <div className={css.buttonsWrapper}>
  //         <span
  //           className={css.link}
  //           role="button"
  //           onClick={() => {
  //             setIsDemoModalOpen(true);
  //           }}
  //         >
  //           <img src={playCircleIcon} alt="Watch demo" />
  //           <span>
  //             <FormattedMessage id="HoverMenuWide.watchDemo" />
  //           </span>
  //         </span>
  //         <SmartLink
  //           className={css.link}
  //           href="https://calendly.com/themodernbuilder/customer-experience"
  //           isExternal
  //           onClick={() => setHoverMenuOpened(null)}
  //         >
  //           <img src={speakIcon} alt="Speak to the team" />
  //           <span>
  //             <FormattedMessage id="HoverMenuWide.speakTeam" />
  //           </span>
  //         </SmartLink>
  //       </div>
  //     </div>
  //     {demoVideoModal}
  //   </div>
  // );
};

HoverMenuWide.propTypes = {
  hoverMenuOpened: PropTypes.string,
  setHoverMenuOpened: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

HoverMenuWide.defaultProps = {
  hoverMenuOpened: null,
  isAuthenticated: false,
};

export default HoverMenuWide;
